(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/same-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/same-device.js');

'use strict';

const AuthenticateEvents = svs.accountservices.authenticate.definitions.Events;
svs.player_login.views.bankid.SameDevice = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.bankid_same_device(data);
  },
  behaviors: [svs.player_login.behaviors.About, svs.player_login.behaviors.Login, svs.player_login.behaviors.Navigation],
  ui: {
    loginButton: '.js-login'
  },
  events: {
    'click @ui.loginButton': 'onLoginClick'
  },
  initialize() {
    svs.accountservices.authenticate.login.on(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll, this);
  },
  onLoginClick() {
    this.triggerMethod('block:navigation');
    svs.accountservices.authenticate.login.start({
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onReadyToPoll() {
    svs.player_login.router.navigate("bankid/poll?".concat(this.model.toQueryString()), true);
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll);
  }
});

 })(window);